import { LICENSE_AGREEMENT_TEXT } from "../data/licenseAgreementText";

export const LICENSE_AGREEMENT_ROUTE = "/license-agreement";
export const LICENSE_AGREEMENT_LINK_LABEL = "соглашение";
export { LICENSE_AGREEMENT_TEXT };

export type LicenseAgreementRenderRow =
  | { kind: "line"; line: string }
  | { kind: "lineWithLinkMid"; before: string; after: string }
  | { kind: "lineWithLinkTail"; before: string };

export function buildLicenseAgreementRenderRows(text: string): LicenseAgreementRenderRow[] {
  const parts = text.split("по адресу: соглашение");
  const chunks =
    parts.length === 2
      ? [`${parts[0]}по адресу: `, parts[1]]
      : [text];
  const rows: LicenseAgreementRenderRow[] = [];
  let skipFirstLineOfNextChunk = false;

  for (let ci = 0; ci < chunks.length; ci++) {
    const lines = chunks[ci].split("\n");
    const startLi = skipFirstLineOfNextChunk ? 1 : 0;
    skipFirstLineOfNextChunk = false;

    for (let li = startLi; li < lines.length; li++) {
      const isLastLineOfChunk = li === lines.length - 1;
      const hasLinkAfter = ci < chunks.length - 1;

      if (isLastLineOfChunk && hasLinkAfter) {
        const nextChunk = chunks[ci + 1];
        if (nextChunk.startsWith("\n")) {
          rows.push({ kind: "lineWithLinkTail", before: lines[li] });
        } else {
          const nextLines = nextChunk.split("\n");
          rows.push({
            kind: "lineWithLinkMid",
            before: lines[li],
            after: nextLines[0] ?? "",
          });
          skipFirstLineOfNextChunk = true;
        }
      } else {
        rows.push({ kind: "line", line: lines[li] });
      }
    }
  }

  return rows;
}
